<template>
  <div class="wechatComplaint div-layout">
    <div class="wechatComplaint-main">
      <div class="wechatComplaint-main-contain">
        <module-title :title="`心电贴录入数据`">
          <div class="right">
            <el-button type="primary" size="medium" @click="addRow()">
              单个添加
            </el-button>
            <el-button
              type="primary"
              size="medium"
              @click="imports"
            >
              批量导入
            </el-button>
            <el-button type="primary" size="medium" @click="exportExcel">
              批量导出
            </el-button>
          </div>
        </module-title>
        <el-form
          ref="searchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          label-width="120px"
        >
          <el-form-item label="联系人号码：" prop="phone">
            <el-input
              v-model="searchForm.phone"
              name="phone"
              placeholder="请输入联系人号码"
              class="handle-form-input"
              maxlength="11"
              clearable
              @input="numberInput"
            />
          </el-form-item>
          <el-form-item v-if="isSchool" label="校牌SIM卡号：" prop="sim">
            <el-input
              v-model="searchForm.sim"
              name="sim"
              placeholder="请输入校牌SIM卡号"
              class="handle-form-input"
              maxlength="11"
              clearable
              @input="numberInputSim"
            />
          </el-form-item>
          <el-form-item label="姓名：" prop="name">
            <el-input
              v-model="searchForm.name"
              name="name"
              maxlength="10"
              placeholder="请输入姓名"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="核销日期：" prop="time">
            <el-date-picker
              v-model="searchForm.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="起始时间"
              end-placeholder="截至时间"
              class="handle-form-input"
              :picker-options="pickerOptions"
              @change="handleChangeDate"
            />
          </el-form-item>
          <el-form-item label="所属区域：" prop="areaCode">
            <el-cascader
              v-model="searchForm.areaCode"
              :options="areaData"
              :props="areaProps"
              class="handle-form-input"
              clearable
              placeholder="选择省/市/区县"
              @change="areaChange"
            />
          </el-form-item>
          <el-form-item label="所属街道：" prop="streetId">
            <el-select
              v-model="searchForm.streetId"
              name="streetId"
              size="medium"
              class="handle-form-input"
              clearable
              @change="fetchCommunitys"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in streetsList"
                :key="item.id"
                :label="item.streetName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所属社区：" prop="communityId">
            <el-select
              v-model="searchForm.communityId"
              name="communityId"
              size="medium"
              class="handle-form-input"
              clearable
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in communitysList"
                :key="item.id"
                :label="item.communityName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
            <el-button
              size="medium"
              icon="el-icon-refresh-right"
              @click="handleSearchReset"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="联系人号码" prop="phone" align="center" />
          <el-table-column label="姓名" prop="name" align="center" />
          <el-table-column label="身份证号" prop="idCard" align="center" />
          <el-table-column label="所属区域" prop="areaJoinName" align="center" />
          <el-table-column label="所属街道" prop="streeName" align="center" />
          <el-table-column label="领取社区" prop="communityName" align="center" />
          <el-table-column label="设备序列号" prop="serialNum" align="center" width="125" />
          <el-table-column label="核销日期" prop="destoryDate" width="120px" align="center" />
          <el-table-column label="备注" width="220px">
            <template slot-scope="{ row }">
              <span :title="row.remark">{{ row.remark | substring(50) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="updateRow(row)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog v-if="dialogFormVisible" :title="windowType ==='add' ? '新增核销心电贴数据' : '编辑核销心电贴数据'" width="650px" :visible.sync="dialogFormVisible">
      <el-form
        ref="addApplicationForm"
        class="add-form"
        :model="form"
        :rules="handleRules"
        label-position="left"
      >
        <el-form-item label="姓名：" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off" maxlength="15" style="width:222px" />
        </el-form-item>
        <el-form-item label="联系人号码：" :label-width="formLabelWidth" prop="phone">
          <el-input v-model.number="form.phone" maxlength="15" autocomplete="off" style="width:222px" />
        </el-form-item>
        <el-form-item label="身份证号：" :label-width="formLabelWidth" prop="idCard">
          <el-input v-model="form.idCard" maxlength="20" autocomplete="off" style="width:222px" />
        </el-form-item>
        <el-form-item label="设备序列号：" :label-width="formLabelWidth" prop="serialNum">
          <el-input v-model="form.serialNum" maxlength="15" autocomplete="off" style="width:222px" />
        </el-form-item>
        <el-form-item label="核销日期：" :label-width="formLabelWidth" prop="destoryDate">
          <el-date-picker
            v-model="form.destoryDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="所属区域：" prop="areaCode" :label-width="formLabelWidth">
          <el-cascader
            v-model="form.areaCode"
            :options="areaData"
            :props="areaProps"
            class="handle-form-input"
            clearable
            placeholder="选择省/市/区县"
            @change="areaChangeAdd"
          />
        </el-form-item>
        <el-form-item label="所属街道：" prop="streetId" :label-width="formLabelWidth">
          <el-select
            v-model="form.streetId"
            name="streetId"
            size="medium"
            class="handle-form-input"
            clearable
            @change="fetchCommunitys"
          >
            <el-option
              v-for="item in streetsList"
              :key="item.id"
              :label="item.streetName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属社区：" prop="communityId" :label-width="formLabelWidth">
          <el-select
            v-model="form.communityId"
            name="communityId"
            size="medium"
            class="handle-form-input"
            clearable
          >
            <el-option
              v-for="item in communitysList"
              :key="item.id"
              :label="item.communityName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth">
          <el-input v-model.trim="form.remark" type="textarea" :rows="4" show-word-limit maxlength="1000" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="OK()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogUploadVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogUploadVisible"
      title="批量导入"
      width="540px"
    >
      <div class="textCenter">
        <el-button type="primary" style=" margin-bottom: 20px" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate">
          下载模板
        </el-button>
        <el-upload
          ref="upload"
          :on-success="onSuccess"
          :action="uploadUrl"
          :headers="uploadHeader"
          :on-progress="onProgress"
          :on-error="onError"
          :multiple="false"
          :limit="1"
          name="file"
          accept=".xls, .xlsx"
          class="handle-btn"
          :data="uploadSubmitData"
        >
          <el-button
            :loading="fileUploading"
            size="medium"
            type="primary"
            icon="el-icon-upload2"
          >
            {{ fileUploading?'上传文件中...':'上传文件' }}
          </el-button>
        </el-upload>
      </div>
    </el-dialog>
    <el-dialog
      title="导入异常"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
    >
      <div class="import-tips">
        导入失败，存在{{ errList&&errList.length>0?errList.length:0 }}条异常记录，请修改重新上传
      </div>
      <el-table
        :data="errList"
        :cell-style="setCellColor"
        style="width: 100%"
      >
        <el-table-column type="index" width="55" align="center" label="序号" />
        <el-table-column
          prop="errorMsg"
          label="错误原因"
          width="650"
        />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  get_sdestoryList_Register,
  exportsTable,
  registerAdd,
  registerUpdate,
  listImport,
  usermanagerExcelTemplate
} from '@/api/systemMaintenance/devicManage/schoolReserveRecord';
import { getStreets, getCommunitys } from '@/api/systemMaintenance/devicManage/cascaderConfig';
import { mapGetters } from 'vuex';
import { getDateTime } from '@/utils/index';
import { getToken } from '@/utils/auth';
import { validateEecgRegisterName, validatEecgRegisterPhone, validateEecgRegisterIcCard, validateEecgRegisterNum } from '@/utils/validate';
export default {
  name: 'EcgRegister',
  props: {
    propsData: {
      type: Object,
      default: function() {
        return { destoryType: 2 };
      }
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      handleRules: {
        name: [{ required: true, trigger: 'blur', validator: validateEecgRegisterName }],
        phone: [{ required: true, trigger: 'blur', validator: validatEecgRegisterPhone }],
        idCard: [{ required: true, trigger: 'blur', validator: validateEecgRegisterIcCard }],
        serialNum: [{ required: true, trigger: 'blur', validator: validateEecgRegisterNum }],
        destoryDate: [{ required: true, message: '此项为必填项', trigger: 'blur' }],
        areaCode: [{ required: true, message: '此项为必填项', trigger: 'blur' }],
        streetId: [{ required: true, message: '此项为必填项', trigger: 'blur' }],
        communityId: [{ required: true, message: '此项为必填项', trigger: 'blur' }]
      },
      dialogUploadVisible: false,
      windowType: 'add',
      uploadUrl: '', // 上传文件URL
      fileUploading: false, // 文件上传加载
      dialogVisible: false,
      uploadHeader: {
      }, // 上传文件上传头
      uploadSubmitData: {},
      form: {
        areaCode: '',
        phone: '', // 类型：String  必有字段  备注：电话
        name: '', // 类型：String  必有字段  备注：姓名
        idCard: '', // 类型：String  必有字段  备注：身份证号
        serialNum: '', // 类型：String  必有字段  备注：序列号
        destoryDate: '', // 类型：String  必有字段  备注：核销日期
        provinceId: '', // 类型：String  必有字段  备注：省
        cityId: '', // 类型：String  必有字段  备注：市
        areaId: '', // 类型：String  必有字段  备注：区
        streetId: '', // 类型：String  必有字段  备注：街道
        communityId: '', // 类型：String  必有字段  备注：社区
        remark: null // 类型：String  必有字段  备注：备注
      },
      formLabelWidth: '110px',
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      ajaxLoading: false,
      isSchool: false,
      // 搜索表单
      searchForm: {
        serialNum: '',
        phone: '',
        name: '',
        sim: '',
        subscriStartDate: '',
        subscriEndDate: '',
        time: [],
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        streetId: '',
        communityId: '',
        destoryType: '', // 预约类型 1-预约校牌 2-预约心电贴
        getCode: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      errList: [],
      dateTime: '',
      updateRowId: '',
      dataList: [],
      streetsList: [],
      communitysList: [],
      listLoading: false, // 表格刷新loading
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() < Date.now(); // 如果没有后面的-8.64e7就是不可以选择今天
        }
      } // 时间控件限制
    };
  },
  watch: {
    // 路由监听赋值三级菜单
    propsData: {
      handler: function(val, oldVal) {
        this.searchForm.destoryType = val.destoryType;
        this.searchForm.destoryType === 1 ? (this.isSchool = true) : (this.isSchool = false);
      },
      // $route这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['areaData', 'userInfo'])
  },
  mounted() {
    this.$store.dispatch('getNodes'); // 获取区域
    this.fetchdataList();
  },
  methods: {
    handleChangeDate(val) {
      if (val && val.length > 0) {
        this.searchForm.subscriStartDate = val[0];
        this.searchForm.subscriEndDate = val[1];
      } else {
        this.searchForm.subscriStartDate = '';
        this.searchForm.subscriEndDate = '';
      }
    },
    setCellColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return 'color:red';
      }
    },
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
    },
    // 下载模板
    handlerExcelTemplate() {
      window.location.href = usermanagerExcelTemplate();
    },
    // 导入加载
    onProgress() {
      this.fileUploading = true;
    },
    // 导入上传失败
    onError() {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      this.$message({
        message: '文件上传失败',
        type: 'error'
      });
    },
    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.fetchdataList();
        this.dialogUploadVisible = false;
      } else {
        if (response.data) {
          this.errList = response.data;
          this.dialogVisible = true;
        } else {
          this.$message({
            showClose: true,
            customClass: 'update-message',
            message: response.message,
            type: 'error'
          });
        }
      }
    },
    imports() { // 批量导入
      this.dialogUploadVisible = true;
      this.uploadUrl = listImport();
    },
    addRow() {
      this.dialogFormVisible = true;
      this.windowType = 'add';
      for (var key in this.form) {
        this.form[key] = '';
      }
    },
    updateRow(val) {
      this.windowType = 'edit';
      this.updateRowId = val.id;
      this.dialogFormVisible = true;
      this.fetchStreet(val);
      this.fetchCommunitys(val.streetId);
      setTimeout(() => {
        this.form = {
          areaCode: [val.provinceId, val.cityId, val.areaId],
          phone: val.phone, // 类型：String  必有字段  备注：电话
          name: val.name, // 类型：String  必有字段  备注：姓名
          idCard: val.idCard, // 类型：String  必有字段  备注：身份证号
          serialNum: val.serialNum, // 类型：String  必有字段  备注：序列号
          destoryDate: val.destoryDate, // 类型：String  必有字段  备注：核销日期
          streetId: val.streetId, // 类型：String  必有字段  备注：街道
          communityId: val.communityId, // 类型：String  必有字段  备注：社区
          remark: val.remark // 类型：String  必有字段  备注：备注
        };
      }, 500);
    },
    OK() {
      const data = {
        phone: this.form.phone, // 类型：String  必有字段  备注：电话
        name: this.form.name, // 类型：String  必有字段  备注：姓名
        idCard: this.form.idCard, // 类型：String  必有字段  备注：身份证号
        serialNum: this.form.serialNum, // 类型：String  必有字段  备注：序列号
        destoryDate: this.form.destoryDate, // 类型：String  必有字段  备注：核销日期
        provinceId: this.form.provinceId, // 类型：String  必有字段  备注：省
        cityId: this.form.cityId, // 类型：String  必有字段  备注：市
        areaId: this.form.areaId, // 类型：String  必有字段  备注：区
        streetId: this.form.streetId, // 类型：String  必有字段  备注：街道
        communityId: this.form.communityId, // 类型：String  必有字段  备注：社区
        remark: this.form.remark, // 类型：String  必有字段  备注：备注
        createUserCode: this.userInfo.code // 类型：String  必有字段  备注：创建人
      };
      this.$refs['addApplicationForm'].validate(valid => {
        this.form.createUserCode = this.userInfo.code;
        if (valid) {
          if (this.windowType === 'add') {
            registerAdd(data).then(res => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.dialogFormVisible = false;
              this.fetchdataList();
            });
          } else {
            registerUpdate(this.updateRowId, data).then(res => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.dialogFormVisible = false;
              this.fetchdataList();
            });
          }
        }
      });
    },
    // 限制input只能输入数字
    numberInput(val) {
      if (val) {
        this.searchForm.phone = val.replace(/[^\d.]/g, '');
      }
    },
    // 限制input只能输入数字
    numberInputSim(val) {
      if (val) {
        this.searchForm.sim = val.replace(/[^\d.]/g, '');
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchdataList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchdataList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchdataList();
    },
    goLink(code) {
      var link = '';
      if (this.isSchool) {
        link = '/youthTrack/devicReceiveManage/schoolReserveRecord';
      } else {
        link = '/ecgStickers/devicReceiveManage/ecgStickersReserveRecord';
      }
      this.$router.push({ path: link, query: { getCode: code }});
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 重置
    handleSearchReset() {
      this.searchForm = {
        phone: '',
        time: '',
        name: '',
        sim: '',
        serialNum: '',
        subscriStartDate: '',
        subscriEndDate: '',
        areaCode: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        streetId: '',
        communityId: '',
        destoryType: this.propsData.destoryType, // 预约类型 1-预约校牌 2-预约心电贴
        getCode: this.propsData.getCode,
        pageNum: 1,
        total: 0,
        pageSize: 10
      };
      this.streetsList = [];
      this.communitysList = [];
      this.fetchdataList();
    },
    // 选择省市区
    areaChange(val) {
      this.searchForm.provinceId = val[0] ? val[0] : '';
      this.searchForm.cityId = val[1] ? val[1] : '';
      this.searchForm.areaId = val[2] ? val[2] : '';
      this.searchForm.streetId = '';
      this.fetchStreet(this.searchForm);
    },
    areaChangeAdd(val) {
      this.form.provinceId = val[0] ? val[0] : '';
      this.form.cityId = val[1] ? val[1] : '';
      this.form.areaId = val[2] ? val[2] : '';
      this.form.streetId = '';
      this.form.communityId = '';
      this.communitysList = [];
      this.fetchStreet(this.form);
    },
    // 设置默认时间
    dafaultVulue() {
      this.searchForm.time = [getDateTime(-1), getDateTime(-1)];
    },
    // 获取街道
    fetchStreet(val) {
      var op = {
        provinceId: val.provinceId,
        cityId: val.cityId,
        areaId: val.areaId
      };
      getStreets(op)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.streetsList = res.data;
          } else {
            this.streetsList = [];
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.warning('请求错误');
        });
    },
    // 获取社区
    fetchCommunitys(val) {
      var op = {
        streetId: this.searchForm.streetId || val
      };
      getCommunitys(op)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.communitysList = res.data;
          } else {
            this.communitysList = [];
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.warning('请求错误');
        });
    },
    // 导出
    exportExcel() {
      this.getTime();
      var data = {
        phone: this.searchForm.phone,
        name: this.searchForm.name,
        destoryStrartDate: this.searchForm.subscriStartDate,
        destoryEndDate: this.searchForm.subscriEndDate,
        provinceId: this.searchForm.provinceId,
        cityId: this.searchForm.cityId,
        areaId: this.searchForm.areaId,
        streetId: this.searchForm.streetId,
        communityId: this.searchForm.communityId,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      exportsTable(data).then((res) => {
        console.log(res);
      }).catch((e) => {
        const blob = new Blob([e.data], {
          type: 'application/vnd.ms-excel'
        });
        const fileName = Date.parse(new Date()) + '.xlsx';
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          // 释放内存
          window.URL.revokeObjectURL(link.href);
        }
      });
    },
    getTime() {
      if (this.searchForm.time && this.searchForm.time.length > 0) {
        this.searchForm.subscriStartDate = this.searchForm.time[0];
        this.searchForm.subscriEndDate = this.searchForm.time[1];
      } else {
        this.searchForm.subscriStartDate = '';
        this.searchForm.subscriEndDate = '';
      }
    },
    // 获取应用列表
    fetchdataList() {
      this.streetsList = [];
      this.communitysList = [];
      this.listLoading = true;
      this.getTime();
      var op = {
        phone: this.searchForm.phone,
        name: this.searchForm.name,
        destoryStrartDate: this.searchForm.subscriStartDate,
        destoryEndDate: this.searchForm.subscriEndDate,
        provinceId: this.searchForm.provinceId,
        cityId: this.searchForm.cityId,
        areaId: this.searchForm.areaId,
        streetId: this.searchForm.streetId,
        communityId: this.searchForm.communityId,
        destoryType: this.searchForm.destoryType, // 预约类型 1-预约校牌 2-预约心电贴
        getCode: this.searchForm.getCode,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      if (this.isSchool) {
        op.sim = this.searchForm.sim;
      }
      get_sdestoryList_Register(op)
        .then((result) => {
          if (result.data && result.data.list && result.data.list.length) {
            this.dataList = result.data.list;
            this.searchForm.total = result.data.total;
            this.dataList = this.dataList.map((v) => {
              this.$set(v, 'edit', false); // https://vuejs.org/v2/guide/reactivity.html
              v.originalTitle = v.title; //  will be used when user click the cancel botton
              return v;
            });
          } else {
            this.dataList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.dataList = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.wechatComplaint {
  padding-bottom: 20px;
  .handle-form-input {
    // width: 80%;
  }
  .link {
    color: rgb(64, 158, 255);
    text-decoration: underline;
    cursor: pointer;
  }
}
.add-form{
  margin-left: 40px;
}
.import-tips{
  margin-bottom: 20px;
  margin-left: 4px;
}
/deep/.el-dialog__body{
  padding: 20px  20px!important;
}
</style>
